import type { T } from '../../i18n';
import { CHAPTERS } from '../../chapters/registry';
import type { Nav } from '../../hooks/useHashRoute';

interface Props {
  t: T;
  route: string;
  onNav: Nav;
}

interface NavItem {
  id: string;
  num: string;
  label: string;
  prio?: string;
}

export function Sidebar({ t, route, onNav }: Props) {
  const homeItem: NavItem = { id: 'home', num: '0', label: t('home.allchapters') };
  const chapterItems: NavItem[] = CHAPTERS.map((c) => ({
    id: c.id,
    num: c.num,
    label: t(`${c.id}.short`),
    prio: c.prio,
  }));

  const renderItem = (item: NavItem) => {
    const active = route === item.id;
    return (
      <li key={item.id} className="chapter-item-wrap">
        <a
          href={`#${item.id}`}
          className="chapter-item"
          data-nav-item={item.id}
          data-active={active || undefined}
          aria-current={active ? 'page' : undefined}
          onClick={(e) => {
            e.preventDefault();
            onNav(item.id);
          }}
        >
          <span className="chapter-num">§{item.num}</span>
          <span className="chapter-title">{item.label}</span>
          {item.prio ? (
            <span className="chapter-prio" data-prio={item.prio}>
              {item.prio}
            </span>
          ) : null}
        </a>
      </li>
    );
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-section">
        <div className="sidebar-label">{t('nav.home')}</div>
        <ul className="chapter-list">{renderItem(homeItem)}</ul>
      </div>
      <div className="sidebar-section">
        <div className="sidebar-label">{t('nav.chapters')}</div>
        <ul className="chapter-list">{chapterItems.map(renderItem)}</ul>
      </div>
    </nav>
  );
}
